import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from "@angular/common/http";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()

export class RequestInterceptor implements HttpInterceptor {
  constructor(
    private spinner: NgxSpinnerService,
    public snackBar: MatSnackBar
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.spinner.show();
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.spinner.hide();
        }

        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        this.spinner.hide();
        this.snackBar.open("Sorry, something went wrong.", "×", {
          panelClass: ['error-popup'],
          verticalPosition: "top",
          duration: 3000,
        });
        const started = Date.now();
        const elapsed = Date.now() - started;
        console.log(
          `Request for ${req.urlWithParams} failed after ${elapsed} ms.`
        );
        return throwError(error);
      })
    );
  }
}